import React, { useState } from "react";
import { ChevronDown, ChevronUp, BarChart3 } from "lucide-react";

const POP = "İstanbul,Bursa,Kocaeli,Ankara,Konya,İzmir,Antalya,Adana,Şanlıurfa,Gaziantep,Mersin,Diyarbakır,Hatay,Manisa,Kayseri,Samsun,Balıkesir,Tekirdağ,Kahramanmaraş,Van,Aydın,Denizli,Sakarya,Muğla,Eskişehir,Mardin,Trabzon,Malatya,Ordu,Erzurum,Afyonkarahisar,Sivas,Tokat,Zonguldak,Batman,Elazığ,Kütahya,Çorum,Şırnak,Çanakkale,Osmaniye,Ağrı,Isparta,Yozgat,Düzce,Edirne,Aksaray,Muş,Kastamonu,Giresun,Uşak,Kırklareli,Niğde,Rize,Adıyaman,Siirt,Bitlis,Hakkari,Karaman,Amasya,Bolu,Kırıkkale,Kırşehir,Nevşehir,Bingöl,Yalova,Burdur,Bilecik,Karabük,Sinop,Çankırı,Artvin,Gümüşhane,Ardahan,Kilis,Bartın,Iğdır,Erzincan,Kars,Tunceli,Bayburt"
  .split(",").map((x) => x.toLocaleUpperCase("tr-TR"));
const rank = (il) => { const i = POP.indexOf(il); return i < 0 ? 999 : i; };

export const IlReport = ({ list }) => {
  const [open, setOpen] = useState(false);
  const [sel, setSel] = useState(null);
  const ils = [...new Set([...list.map((a) => a.merkez_il), ...list.flatMap((a) => a.iller || [])].filter(Boolean))].sort((a, b) => rank(a) - rank(b) || a.localeCompare(b, "tr"));
  const stat = (il) => {
    const here = list.filter((a) => a.merkez_il === il);
    const dest = new Set(here.flatMap((a) => a.iller || []).filter((x) => x !== il));
    return { here, dest, serve: list.filter((a) => (a.iller || []).includes(il)).length };
  };
  const det = sel ? stat(sel) : null;
  return (
    <div data-testid="il-report" className="rounded-lg border border-slate-700 bg-slate-900">
      <button data-testid="il-report-toggle" onClick={() => setOpen(!open)} className="flex w-full items-center gap-2 px-3 py-2 text-xs font-bold text-white">
        <BarChart3 className="h-4 w-4 text-orange-500" /> İL RAPORU — İLLERDEKİ AMBAR SAYILARI ({ils.length} İL)
        {open ? <ChevronUp className="ml-auto h-4 w-4" /> : <ChevronDown className="ml-auto h-4 w-4" />}
      </button>
      {open && (
        <div className="space-y-3 border-t border-slate-800 p-3">
          <div className="grid grid-cols-2 gap-2 sm:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8">
            {ils.map((il) => { const s = stat(il); return (
              <button key={il} data-testid={`il-card-${il}`} onClick={() => setSel(sel === il ? null : il)}
                className={`rounded-lg border p-2 text-left transition-colors ${sel === il ? "border-orange-500 bg-orange-500/10" : "border-slate-700 bg-slate-800 hover:border-blue-500"}`}>
                <div className="truncate text-xs font-extrabold text-white">{il}</div>
                <div className="mt-1 flex items-baseline gap-1"><span data-testid={`il-card-count-${il}`} className="text-2xl font-black text-blue-500">{s.here.length}</span><span className="text-[10px] text-slate-400">AMBAR</span></div>
                <div className="text-[10px] text-slate-400"><b className="text-slate-200">{s.dest.size}</b> İLE GİDİYOR</div>
                <div className="text-[10px] text-slate-400"><b className="text-slate-200">{s.serve}</b> AMBAR BU İLE GELİYOR</div>
              </button>); })}
          </div>
          {det && (
            <div data-testid="il-report-detail" className="rounded-lg border border-orange-600 bg-slate-950 p-2">
              <div className="mb-1 text-xs font-bold text-white">{sel} — ADRESİ BU İLDE OLAN {det.here.length} AMBAR · {det.dest.size} İLE GİDİYOR</div>
              {det.here.length ? (
                <table className="w-full text-xs text-slate-200">
                  <thead className="bg-slate-800 text-left text-[10px] text-slate-400"><tr>{["AMBAR ADI", "YETKİLİ", "GSM", "S.TEL", "İLÇE", "GİTTİĞİ İLLER"].map((h) => <th key={h} className="px-2 py-1">{h}</th>)}</tr></thead>
                  <tbody>{det.here.map((a) => (
                    <tr key={a.id} data-testid={`il-detail-row-${a.id}`} className="border-b border-slate-800 align-top">
                      <td className="px-2 py-1 font-semibold">{a.ad}</td><td className="px-2">{a.yetkili}</td><td className="px-2">{a.gsm}</td><td className="px-2">{a.tel}</td><td className="px-2">{a.merkez_ilce}</td>
                      <td className="px-2">{(a.iller || []).join(" - ")}</td>
                    </tr>))}</tbody>
                </table>
              ) : <div className="py-2 text-center text-[11px] text-slate-500">ADRESİ BU İLDE OLAN AMBAR YOK (SADECE BU İLE HİZMET VERENLER VAR)</div>}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
